import { BellRingIcon, BookOpenCheckIcon, CableIcon, FileSearchIcon, SlidersHorizontalIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'PID Tuning Quick-Reference & Loop Diagnostic Cards',
    description: 'Compact cards that summarize PID actions, tuning steps and common loop symptoms for fast review.',
    icon: SlidersHorizontalIcon,
  },
  {
    number: '2',
    title: 'Industrial Protocol Cheat Sheets: Modbus, HART, Profibus, DNP3 & OPC UA',
    description: 'Side-by-side summaries of the key concepts, addressing and data models of each protocol.',
    icon: CableIcon,
  },
  {
    number: '3',
    title: 'Control Room Alarm Response & Shift Handover Guide',
    description: 'A structured approach to responding to alarms and passing clear information between shifts.',
    icon: BellRingIcon,
  },
  {
    number: '4',
    title: 'How to Read P&IDs, Loop Diagrams & Control Narratives',
    description: 'How to interpret symbols, tags, loop diagrams and control narratives step by step.',
    icon: FileSearchIcon,
  },
  {
    number: '5',
    title: 'Process Control & SCADA Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used in process control, DCS, SCADA and OT.',
    icon: BookOpenCheckIcon,
  },
];
